import { WEEKLY_FLOW, YOUTUBE_LINK } from "./data/DiscordPageData";

export default function DiscordWeeklyFlow() {
  return (
    <>
      {/* ── WEEKLY RHYTHM ────────────────────────────────────────── */}
      <section className="dsc-section" id="rhythm">
        <div className="dsc-eyebrow">Weekly Rhythm</div>
        <h2 className="dsc-h2">
          How a <span className="hi">week flows</span>
        </h2>
        <p className="dsc-section-sub dsc-wide">
          From the team's first sync to the Commander's final call, the week
          follows one loop. Weeks run Monday to Sunday on Pakistan time, and a
          team's meeting count stays with the team when its captain changes.
        </p>

        <ol className="dsc-flow">
          {WEEKLY_FLOW.map((f) => (
            <li key={f.step} className={`dsc-flow-step tone-${f.tone}`}>
              <span className="dsc-flow-num">{f.step}</span>
              <h3 className="dsc-flow-title">{f.title}</h3>
              <p className="dsc-flow-text">{f.text}</p>
            </li>
          ))}
        </ol>

        <div className="dsc-yt">
          <div>
            <div className="dsc-yt-title">Missed a meeting?</div>
            <p className="dsc-yt-text">
              Captains publish every session to the QuantumLogics YouTube
              channel, so you can catch up and stay aligned.
            </p>
          </div>
          <a
            href={YOUTUBE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="dsc-btn-ghost"
          >
            @QuantumLogicsLimited ↗
          </a>
        </div>
      </section>
    </>
  );
}
